import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { FormHelperText, TextField, Select, MenuItem, InputLabel} from "@material-ui/core";
import IntlMessages from "../util/IntlMessages";
import {useForm} from "react-hook-form";
import {addNewCustomerAction,
    // createNewUserAction
} from "../actions";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {xmlString} from "../constants/customer_industries_xml";
import {KeyboardDatePicker} from "@material-ui/pickers"
import {bbDangerousDateToBBApiDate} from "../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewCustomer} = useSelector(({users}) => users.appMisc);
  const dispatch = useDispatch();

    const [domains, set_domains] = useState("");
    const [ips, set_ips] = useState("");
    const [poc_name, set_poc_name] = useState(null);
    const [poc_email, set_poc_email] = useState(null);
    const [poc_phone, set_poc_phone] = useState(null);
    const [service_requested, set_service_requested] = useState(null);
    const [name, set_name] = useState(null);
    const [comments, set_comments] = useState(null);
    const [customer_size, set_customer_size] = useState(null);
    const [customer_industry, set_customer_industry] = useState(null);
    const [subscription_start, set_subscription_start] = useState(new Date(Date.now()));
    const [subscription_end, set_subscription_end] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)));
    const [name_short, set_name_short] = useState(null);

    // const [localLoading, setLocalLoading] = useState(false);

    const clearForm = () => {
        set_domains("");
        set_ips("");
        set_poc_name("");
        set_poc_email("");
        set_poc_phone("");
        set_service_requested(null);
        set_name("");
        set_comments("");
        set_customer_size(null);
        set_customer_industry(null);
        set_subscription_start(new Date(Date.now()));
        set_subscription_end(new Date(new Date().setMonth(new Date().getMonth() + 1)));
        set_domains("");
        set_name_short("");
        // const tempCustomerId = customerId;
        document.getElementById('NewClientForm').reset();
        // setCustomerId(tempCustomerId);
        // document.getElementById('customerId').value = customerId;
    }

    const industryMenuItemsFromXMLString = () => {
        let XMLParser = require('react-xml-parser');
        const xmlObject = new XMLParser().parseFromString(xmlString);
        // console.log("converted industry xml", xmlObject)
        return xmlObject.children.map((industryDataObject) => <MenuItem key={`industry_menu_item${industryDataObject.children[0].value}`} value={industryDataObject.children[0].value}>{industryDataObject.children[1].value}</MenuItem>)
    }

  useEffect(() => {
    if(didJustCreateNewCustomer) {
        clearForm();
    }
    // setLocalLoading(false);
  }, [dispatch, didJustCreateNewCustomer]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        // setLocalLoading(true);
        // console.log("Trying to create a new customer with data of ", data);
        // console.log("domains", domains);
        // console.log("ips", ips);
        // console.log("poc_name", poc_name);
        // console.log("poc_email", poc_email);
        // console.log("service_requested", service_requested);
        // console.log("name", name);
        // console.log("comments", comments);
        // console.log("customer_size", customer_size);
        // console.log("customer_industry", customer_industry);
        // console.log("subscription_start", subscription_start);
        // console.log("subscription_end", subscription_end);
        // console.log("name_short", name_short);

        dispatch(addNewCustomerAction({
            "domains": domains,
            "ips": ips,
            "poc_name": poc_name,
            "poc_email": poc_email,
            "poc_phone": poc_phone,
            "service_requested": service_requested,
            "name": name,
            "comments": comments,
            "customer_size": customer_size,
            "customer_industry": customer_industry,
            "subscription_start": bbDangerousDateToBBApiDate(subscription_start),
            "subscription_end": bbDangerousDateToBBApiDate(subscription_end),
            "name_short": name_short,
        }));
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            <h2>Create New Client</h2>
            <p>This will create a new client for BreachRisk CIRT.</p>

            <form id={"NewClientForm"} className={classes.root}>
                <h3>Company & Attack Surface</h3>

                    <TextField
                        label={<IntlMessages id="appModule.newClient.name"/>}

                        // fullWidth
                        id="name"
                        name="name"
                        required
                        error={!!errors.name}
                        onChange={(event) => set_name(event.target.value)}
                        defaultValue={name}
                        margin="normal"
                        className="mt-1 my-sm-3"
                        inputRef={register({
                            required: "This field is required." ,
                        })}
                        helperText={(!errors.name && "Full, Legal Name of Client") || errors.name?.message}
                    />
                    <TextField
                        label={<IntlMessages id="appModule.newClient.name_short"/>}
                        // fullWidth
                        id="name_short"
                        name="name_short"
                        required
                        error={!!errors.name_short}
                        onChange={(event) => set_name_short(event.target.value)}
                        defaultValue={name_short}
                        margin="normal"
                        className="mt-1 my-sm-3"
                        inputRef={register({
                            required: "This field is required." ,

                        })}
                        helperText={(!errors.name_short && "For casual use cases") || errors.name_short?.message}
                    />
                <br/>

                <FormControl className={classes.formControl}>
                    <InputLabel
                        id="appModule.newClient.customer_industry-label"
                        required
                        error={!!errors.customer_industry}
                    >
                        <IntlMessages id="appModule.newClient.customer_industry"/>
                    </InputLabel>
                    <Select
                        labelId="appModule.newClient.customer_industry-label"
                        id="customer_industry"
                        name="customer_industry"
                        value={customer_industry}
                        onChange={(event) => set_customer_industry(event.target.value)}
                        displayEmpty
                        // className={classes.selectEmpty}
                        // inputProps={{
                        //     inputRef: (ref) => {
                        //         register({
                        //             required: "This field is required.",
                        //         });
                        //     }
                        // }}
                    >
                        {industryMenuItemsFromXMLString()}
                    </Select>
                </FormControl>
                <br/>
                <TextField
                    label={<IntlMessages id="appModule.newClient.domains"/>}
                    fullWidth
                    id="domains"
                    name="domains"
                    required
                    error={!!errors.domains}
                    onChange={(event) => set_domains(event.target.value)}
                    defaultValue={domains}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    })}
                    helperText={(!errors.domains && "Separate multiple domains by a comma.") || (errors.domains?.type === "pattern" && "Multiple domains must be separated by a comma.") || errors.domains?.message}
                />
                <TextField
                    label={<IntlMessages id="appModule.newClient.ips"/>}
                    fullWidth
                    id="ips"
                    name="ips"
                    required
                    error={!!errors.ips}
                    onChange={(event) => set_ips(event.target.value)}
                    defaultValue={ips}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    })}
                    helperText={(!errors.ips && "Separate multiple subdomains or IPs by a comma.") || (errors.ips?.type === "pattern" && "Multiple subdomains or IPs must be separated by a comma.") || errors.ips?.message}
                />
                <h3>Subscription Details</h3>
                <FormControl className={classes.formControl}>
                    <InputLabel
                        id="appModule.newClient.customer_size-label"
                        required
                        error={!!errors.customer_size}
                    >
                        <IntlMessages id="appModule.newClient.customer_size"/>
                    </InputLabel>
                    <Select
                        labelId="appModule.newClient.customer_size-label"
                        id="customer_size"
                        name="customer_size"
                        value={customer_size}
                        onChange={(event) => set_customer_size(event.target.value)}
                        displayEmpty
                        // className={classes.selectEmpty}
                    >
                        <MenuItem value={0}>Micro (0)</MenuItem>
                        <MenuItem value={1}>Small (1)</MenuItem>
                        <MenuItem value={2}>Mid-Sized (2)</MenuItem>
                        <MenuItem value={3}>Enterprise (3)</MenuItem>
                        <MenuItem value={4}>Large Enterprise (4)</MenuItem>
                    </Select>
                    <FormHelperText
                        error={!!errors.customer_size}
                    >
                        {errors.customer_size? errors.customer_size?.message : " "}
                    </FormHelperText>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <InputLabel
                        id="appModule.newClient.service_requested-label"
                        required
                        error={!!errors.service_requested}
                    >
                        <IntlMessages id="appModule.newClient.service_requested"/>
                    </InputLabel>
                    <Select
                        labelId="appModule.newClient.service_requested-label"
                        id="service_requested"
                        name="service_requested"
                        value={service_requested}
                        onChange={(event) => set_service_requested(event.target.value)}
                        displayEmpty
                        // className={classes.selectEmpty}
                    >
                        <MenuItem value={3}>BreachRisk&trade; Portfolio</MenuItem>
                        <MenuItem value={2}>BreachRisk&trade; for Business</MenuItem>
                        <MenuItem value={1}>Continuous Intelligent Red Team&trade; (CIRT)</MenuItem>

                    </Select>
                    <FormHelperText
                        error={!!errors.service_requested}
                    >
                        {errors.service_requested? errors.service_requested?.message : " "}
                    </FormHelperText>
                </FormControl>
                <br/>
                <KeyboardDatePicker
                    className={classes.formControl}
                    margin="normal"
                    id="subscription_start"
                    name="subscription_start"
                    label={<IntlMessages id="appModule.newClient.subscription_start"/>}
                    required
                    format="MM/DD/yyyy"
                    // value={subscription_start}
                    value={subscription_start}
                    minDate={new Date()}
                    error={!!errors.subscription_start}
                    onChange={(date) => set_subscription_start(date)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputRef={register({
                        required: "This field is required." ,
                        valueAsDate: true,
                    })}
                    helperText={errors.subscription_start?.message}
                />

                <KeyboardDatePicker
                    className={classes.formControl}
                    margin="normal"
                    id="subscription_end"
                    name="subscription_end"
                    label={<IntlMessages id="appModule.newClient.subscription_end"/>}
                    required
                    format="MM/DD/yyyy"
                    value={subscription_end}
                    minDate={new Date()}
                    // defaultValue={subscription_end}
                    error={!!errors.subscription_end}
                    onChange={(date) => set_subscription_end(date)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputRef={register({
                        required: "This field is required." ,
                        // validate: value => value > subscription_start || "End date must be after start date.",
                        valueAsDate: true,
                    })}
                    helperText={errors.subscription_end?.message}
                />
                <h3>Point of Contact</h3>
                <TextField
                    label={<IntlMessages id="appModule.newClient.poc_name"/>}
                    // fullWidth
                    id="poc_name"
                    name="poc_name"
                    required
                    error={!!errors.poc_name}
                    onChange={(event) => set_poc_name(event.target.value)}
                    defaultValue={poc_name}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.poc_name?.message}
                />
                <TextField
                    label={<IntlMessages id="appModule.newClient.poc_email"/>}
                    // fullWidth
                    id="poc_email"
                    name="poc_email"
                    required
                    error={!!errors.poc_email}
                    onChange={(event) => set_poc_email(event.target.value)}
                    defaultValue={poc_email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

                    })}
                    helperText={errors.poc_email?.type === "pattern" && "Please enter a valid email address." || errors.poc_email?.message}
                />
                <TextField
                    label={<IntlMessages id="appModule.newClient.poc_phone"/>}
                    // fullWidth
                    id="poc_phone"
                    name="poc_phone"
                    required
                    error={!!errors.poc_phone}
                    onChange={(event) => set_poc_phone(event.target.value)}
                    defaultValue={poc_phone}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                        pattern: /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

                    })}
                    helperText={(!errors.poc_phone && "ex: 1234567890 or 123-456-7890 or (123) 456-7890 or +123456789012") || (errors.poc_phone?.type === "pattern" && "Please enter a valid phone number. ex: 1234567890 or 123-456-7890 or (123) 456-7890 or +123456789012") || errors.poc_phone?.message}
                />
                <h3>Internal Comments (optional)</h3>
                <TextField
                    label={<IntlMessages id="appModule.newClient.comments"/>}
                    fullWidth
                    id="comments"
                    name="comments"
                    // required
                    error={!!errors.comments}
                    onChange={(event) => set_comments(event.target.value)}
                    defaultValue={comments}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    //     // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    // })}
                    helperText={ errors.comments?.message}
                />
                <br/>
                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.name || !!errors.name_short || !!errors.subscription_start || !!errors.subscription_end  || !!errors.poc_email || !!errors.poc_name || !!errors.poc_phone || !!errors.service_requested || !!errors.domains || !!errors.ips || !!errors.customer_size || !!errors.customer_industry }
                                variant="contained" color="primary">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form